import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import DashboardService from "./DashboardService";
import { DataForm } from "../../../libs/react-mpk/components";
import moment from "moment";

import {
  SortOrder,
  TableContainer,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
  Caption,
} from "@react-md/table";
import { FontIcon } from "@react-md/icon";
import {
  AppBar,
  AppBarNav,
  AppBarTitle,
  AppBarAction,
} from "@react-md/app-bar";
import { useState } from "react";
import { Line, Circle } from "rc-progress";
import Utils from "../../../libs/custom/Utils";

function SummarySpt21DashboardView({ sipStore }) {
  const [data, setData] = useState({
    loading: true,
    content: [],
    sortKey: "nama",
    sortOrder: "ascending",
    total: 0,
    param: {},
  });

  const [toggleFilter, setToggleFilter] = useState(false);

  useEffect(() => {
    initData("nama", {
      perusahaanId: sipStore.companyId,
      "tahun.equals": "" + sipStore.periode.tahun,
      "bulan.greaterThanOrEqual": "1",
      "bulan.lowerThanOrEqual": "12",
    });
  }, []);

  async function initData(sortKey, param) {
    var d = data.content;
    if (param) {
      param.pageSize = 10000000000;
      delete param.tahun;
      var pph21 = await DashboardService.pelaporanPph21(param);

      d = pph21.data;
    }

    setData((prevState) => {
      const prevSortKey = prevState.sortKey;
      const prevSortOrder = prevState.sortOrder;

      let sortOrder;
      if (sortKey === prevSortKey) {
        // it's the same column, so toggle the sort order
        sortOrder = prevSortOrder === "ascending" ? "descending" : "ascending";
      } else {
        // it's a new column to sort by, so default to ascending for the name column
        // but descending for all the rest.
        sortOrder = sortKey === "name" ? "ascending" : "descending";
      }

      return {
        content: d.sort((a, b) => {
          const aValue = a[sortKey];
          const bValue = b[sortKey];
          const value =
            typeof aValue === "number"
              ? aValue - bValue
              : "" + aValue.localeCompare(bValue);
          return value * (sortOrder === "ascending" ? 1 : -1);
        }),
        sortKey,
        sortOrder,
        param,
        loading: false,
        total: d.reduce((pv, cv) => {
          pv = pv + cv.totalPph;
          return pv;
        }, 0),
      };
    });
  }

  const { content, sortKey, sortOrder } = data;

  return (
    <div
      className="mpk-form-wrapper mpk-paper  padding-all mpk-animation slide-in"
      style={{
        width: "100%",
        maxWidth: 1200,
        margin: "0px auto",
      }}
    >
      <AppBar theme="clear">
        <AppBarTitle className="rmd-typography--capitalize">
          {/* PELAPORAN */}
        </AppBarTitle>

        <AppBarAction
          first
          aria-label="Actions"
          onClick={() => {
            setToggleFilter(!toggleFilter);
          }}
        >
          <FontIcon iconClassName="mdi mdi-filter" />
        </AppBarAction>
      </AppBar>
      <div className="mpk-padding-N" style={{ height: 600, overflow: "auto" }}>
        {toggleFilter && (
          <DataForm
            baseId={"pegawai-import"}
            // asDialog={true}
            defaultData={data.param}
            definitions={[
              {
                inputType: DataForm.inputTypes.INPUT,
                label: "Tahun Pajak",
                key: "tahun.equals",
                theme: "filled",
                validation: "required",
                width: "49%",
                style: { marginRight: "2%", width: "100%" },
              },
              {
                inputType: DataForm.inputTypes.SELECT,
                label: "Masa Pajak Dari",
                key: "bulan.greaterThanOrEqual",
                type: "text",
                style: { marginRight: "2%" },
                width: "49%",
                required: true,
                validation: "required",
                options: [
                  { value: "1", label: "1" },
                  { value: "2", label: "2" },
                  { value: "3", label: "3" },
                  { value: "4", label: "4" },
                  { value: "5", label: "5" },
                  { value: "6", label: "6" },
                  { value: "7", label: "7" },
                  { value: "8", label: "8" },
                  { value: "9", label: "9" },
                  { value: "10", label: "10" },
                  { value: "11", label: "11" },
                  { value: "12", label: "12" },
                ],
              },
              {
                inputType: DataForm.inputTypes.SELECT,
                label: "Masa Pajak Sampai",
                key: "bulan.lowerThanOrEqual",
                type: "text",
                width: "49%",
                required: true,
                validation: "required",
                options: [
                  { value: "1", label: "1" },
                  { value: "2", label: "2" },
                  { value: "3", label: "3" },
                  { value: "4", label: "4" },
                  { value: "5", label: "5" },
                  { value: "6", label: "6" },
                  { value: "7", label: "7" },
                  { value: "8", label: "8" },
                  { value: "9", label: "9" },
                  { value: "10", label: "10" },
                  { value: "11", label: "11" },
                  { value: "12", label: "12" },
                ],
              },
              // {
              //   inputType: DataForm.inputTypes.SELECT,
              //   label: "Kategori Pajak",
              //   key: "type",
              //   theme: "filled",
              //   validation: "required",
              //   options: [
              //     { label: "Pajak Terutang", value: "Pajak Terutang" },
              //     {
              //       label: "Pajak Dibayar Dimuka",
              //       value: "Pajak Dibayar Dimuka",
              //     },
              //   ],
              //   style: { width: "29%" },
              // },
            ]}
            // visible={uploadModal}
            submitLabel="Cari"
            onSubmit={async (d, callback) => {
              try {
                await initData(data.sortKey, {
                  ...d,
                  perusahaanId: sipStore.companyId,
                });
                callback();
              } catch (e) {
                console.log(e.response);
                callback(e.response.data.message);
              }
            }}
          />
        )}
        <TableContainer style={{ minHeight: 600 }}>
          <Table fullWidth>
            <Caption>
              {data.param["bulan.greaterThanOrEqual"]} -{" "}
              {data.param["bulan.lowerThanOrEqual"]}{" "}
              {data.param["tahun.equals"]}
            </Caption>
            <TableHeader>
              {/* <TableRow>
                <TableCell key="tahun">TAHUN</TableCell>
              </TableRow> */}
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>
                  <div>
                    <b>TAHUN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.tahun}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>MASA</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.bulan}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>PEMBETULAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.pembetulan}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>NPWP</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.npwp}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>NAMA</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.nama}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>STATUS</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell style={{ width: 200, textAlign: "center" }}>
                    {v.ntte ? "SUDAH LAPOR" : "BELUM LAPOR"}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow style={{ borderTop: "2px solid black" }}>
                <TableCell>
                  <div>
                    <b>PEGAWAI TETAP</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>DIATAS PTKP</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai01)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto01)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph01)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>DIBAWAH PTKP</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai02)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto02)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph02)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>TOTAL PEGAWAI TETAP</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai03)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto03)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph03)}</TableCell>
                ))}
              </TableRow>
              <TableRow style={{ borderTop: "2px solid black" }}>
                <TableCell>
                  <div>
                    <b>PENERIMA PENGHASILAN PENSIUN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>DIATAS PTKP</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai04)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto04)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph04)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>DIBAWAH PTKP</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai05)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto05)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph05)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>TOTAL PEGAWAI TETAP</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai06)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto06)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph06)}</TableCell>
                ))}
              </TableRow>

              <TableRow style={{ borderTop: "2px solid black" }}>
                <TableCell>
                  <div>
                    <b>TIDAK FINAL</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Upah Pegawai Tidak Tetap".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai07)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto07)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph07)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Imbalan Distributor MLM".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai08)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto08)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph08)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Imbalan Petugas Dinas Luar Asuransi".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai09)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto09)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph09)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Imbalan Penjaja Barang Dagangan".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai10)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto10)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph10)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Imbalan Tenaga Ahli".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai11)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto11)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph11)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Imbalan Bukan Pegawai Penghasilan Berkesinambungan".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai12)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto12)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph12)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Imbalan Bukan Pegawai Penghasilan Tidak Berkesinambungan".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai13)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto13)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph13)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Honorarium Anggota Dewan Komisaris".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai14)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto14)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph14)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Jasa Produksi, Tantiem, Bonus atau Imbalan Mantan Pegawai".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai15)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto15)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph15)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Penarikan Dana Pensiun Oleh Pegawai".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai16)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto16)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph16)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Imbalan Kepada Peserta Kegiatan".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai17)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto17)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph17)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Objek Pph Pasal 21 Tidak Final Lainnya".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai18)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto18)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph18)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Pembayaran Berkala Lainnya Yang Dipotong Pph Pasal 26".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai19)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto19)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph19)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Total Tidak Final".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai20)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto20)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph20)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Penerima pesangon".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai21)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto21)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph21)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Penerima uang manfaat pensiun, THT atau JHT".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai22)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto22)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph22)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Pejabat negara, PNS dan imbalan lain".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai23)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto23)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph23)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Penerima penghasilan yang dipotong PPh pasal 21 final".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai24)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto24)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph24)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '20px'}}>
                    <b>{"Total Final".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "center" }}
                  ></TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PENERIMA PENGHASILAN</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pegawai25)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>BRUTO</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.bruto25)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div style={{paddingLeft: '40px'}}>
                    <b>PPH</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph25)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>JUMLAH KOMPENSASI</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.kompensasi)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>{"PPH Pasal 21 dan atau 26 yang kurang (lebih) disetor pada SPT yang dibetulkan".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph21Btl01)}</TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell>
                  <div>
                    <b>{"PPh Pasal 21 Dan/atau Pasal 26 yang kurang (lebih) disetor karena pembetulan".toUpperCase()}</b>
                  </div>
                </TableCell>
                {data.content.map((v, i) => (
                  <TableCell
                    style={{ width: 200, textAlign: "right" }}
                  >{Utils.numberFormat(v.pph21Btl02)}</TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}

export default inject(
  "sipStore",
  "authStore"
)(observer(SummarySpt21DashboardView));

const colors = [
  "#ef5350",
  "#ff1744",
  "#ec407a",
  "#f50057",
  "#ab47bc",
  "#d500f9",
  "#7e57c2",
  "#651fff",
  "#5c6bc0",
  "#3d5afe",
  "#42a5f5",
  "#2979ff",
  "#29b6f6",
  "#00b0ff",
  "#26c6da",
  "#00e5ff",
  "#26a69a",
  "#1de9b6",
  "#66bb6a",
  "#00e676",
  "#9ccc65",
  "#76ff03",
  "#d4e157",
  "#c6ff00",
  "#ffee58",
  "#ffea00",
  "#ffca28",
  "#ffc400",
  "#ffa726",
  "#ff9100",
  "#ff7043",
  "#ff3d00",
  "#8d6e63",
  "#bdbdbd",
  "#78909c",
];

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
